<template>
  <div class="fadein">
    <div class="h30" id="test"></div>
    <Goback></Goback>
    <transition name="el-zoom-in-center">
      <div class="center1200" v-if="forum.title">
        <!-- 文章 Start -->
        <div class="bg-white" style="padding:20px;">
          <!-- <div class="title">
                <h2>电影论坛</h2>
            </div> -->
          <div class="h10"></div>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/forum' }"
              >论坛</el-breadcrumb-item
            >
            <el-breadcrumb-item>文章详情</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="h20"></div>
          <div class="padding20">
            <h1>{{ forum.title }}</h1>
            <div class="h10"></div>
            <div style="font-size:18px;color:#999;">{{ forum.desn }}</div>
            <div class="forum-bottom">
              <div class="author">
                <img
                  :src="forum.user_info.extras.user_pic"
                  alt=""
                  class="author-pic"
                  v-if="
                    forum.user_info.extras.user_pic !=
                      '//'+ this.$API_URL +''
                  "
                  @click="goUserinfo(forum.author)"
                />
                <img
                  src="/static/img/default_userpic.png"
                  alt=""
                  class="author-pic"
                  v-else
                  @click="goUserinfo(forum.author)"
                />
                <div class="author-name">
                  <span
                    v-if="forum.user_info.extras.nickname != null"
                    @click="goUserinfo(forum.author)"
                    >{{ forum.user_info.extras.nickname }}</span
                  >
                  <span v-else @click="goUserinfo(forum.author)">{{
                    forum.user_info.mobile
                  }}</span>
                </div>
              </div>
              <div class="forum-info">
                <div class="forum-info-son">浏览:{{ forum.reviews_count }}</div>
                <!-- <div class="forum-info-son">有用:{{ forum.useful_count }}</div> -->
                <!-- <div class="forum-info-son">没用:{{ forum.useless_count }}</div> -->
                <div class="forum-info-son">收藏:{{ forum.fav_count }}</div>
              </div>
              <div class="forum-pubdate">
                <div
                  class="forum-pubdate-son forum-action"
                  @click="editForum()"
                  v-if="token == forum.user_info.id"
                >
                  编辑文章
                </div>
                <div
                  class="forum-pubdate-son forum-action"
                  @click="deleteForum()"
                  v-if="token == forum.user_info.id"
                >
                  删除文章
                </div>
                <div class="forum-pubdate-son">{{ forum.updated_at }}</div>
              </div>
            </div>
            <div style="clear: both;"></div>
            <div class="h30"></div>
            <div v-html="forum.content" class="forum-content"></div>
            <!-- <div class="h30"></div> -->
            <el-divider></el-divider>
            <!-- <div style="float:left;line-height: 30px;margin-right: 20px;"><div class="like"></div><span>点赞</span></div> -->
            <div style="float:left;line-height: 30px;" @click="favForum()">
              <div :class="favforum"></div>
              <span>收藏该文章</span>
            </div>
            <div class="forum-pubdate" style="float:right;line-height: 30px;">
              <div
                class="forum-pubdate-son forum-action"
                @click="editForum()"
                v-if="token == forum.user_info.id"
              >
                编辑文章
              </div>
              <div
                class="forum-pubdate-son forum-action"
                @click="deleteForum()"
                v-if="token == forum.user_info.id"
              >
                删除文章
              </div>
              <div
                class="forum-pubdate-son forum-action"
                @click="showForumDialogReport()"
                v-else
              >
                举报文章
              </div>
              <div class="forum-pubdate-son">{{ forum.updated_at }}</div>
            </div>
            <div class="h10"></div>
          </div>
        </div>
        <div class="h20"></div>
        <!-- 文章 End -->
        <div id="test_enter"></div>
        <!-- 影评 Start -->
        <div class="bg-white" style="padding:20px;padding-top:10px">
          <el-divider><span class="center-title">评 论</span></el-divider>
          <div class="h20"></div>
          <div style="width:1100px;margin:0 auto;">
            <span v-if="user_info.level == 0">
              <span
                >在用户首次评论之前，需要填写一份简单的问卷，以达到活跃用户素质的目的；若用户没能完成我们设计的问题，则只能浏览和参与（投票），无法发表言论。我们希望为热爱电影的人群创建一片交流相处的净土，感谢配合
                ヾ(o◕∀◕)ﾉ</span
              ><br /><br />
              <div style="text-align: center;">
                <el-button type="primary" @click="goTest()">GO~</el-button>
              </div>
            </span>
            <span v-else-if="token != null">
              <el-input
                class="content"
                type="textarea"
                :autosize="{ minRows: 5 }"
                placeholder="发表一个友善的评论吧~"
                v-model="content"
              >
              </el-input>
              <div style="text-align:center;">
                <el-button
                  type="primary"
                  style="width:120px;"
                  @click="publishContent()"
                  >发 布</el-button
                >
              </div>
            </span>

            <span v-else>
              <div style="text-align:center;">
                登录后才能参与讨论呀~<br /><br />
                <router-link to="/login">
                  <el-button type="primary" style="width:120px;"
                    >登 录</el-button
                  >
                </router-link>
              </div>
            </span>

            <!-- 评论列表 Start -->
            <div v-for="(v, k) in comments" class="comment-box">
              <div
                style="display: flex;justify-content: space-between;  flex-direction: row;"
              >
                <div v-if="v.level == 1"></div>
                <div v-else style="width:50px;height:80px;"></div>
                <div style="width:100%;">
                  <el-divider></el-divider>
                  <!-- 用户没有完善资料 -->
                  <span
                    v-if="
                      v.user_info.extras.user_pic == 'http://'+ $API_URL
                    "
                  >
                    <img
                      src="/static/img/default_userpic.png"
                      alt=""
                      class="comment-head"
                      @click="goUserinfo(v.user_id)"
                    />
                  </span>
                  <span v-else>
                    <img
                      :src="v.user_info.extras.user_pic"
                      alt=""
                      class="comment-head"
                      @click="goUserinfo(v.user_id)"
                    />
                  </span>

                  <!-- 用户完善了资料 -->
                  <span v-if="v.user_info.extras.nickname == null">
                    <div class="comment-title" @click="goUserinfo(v.user_id)">
                      {{ v.user_info.mobile }}
                    </div>
                  </span>
                  <span v-else>
                    <div class="comment-title" @click="goUserinfo(v.user_id)">
                      {{ v.user_info.extras.nickname }}
                    </div>
                  </span>

                  <div style="clear: both;"></div>
                  <div class="comment-body">
                    <a
                      style="color:#ff7400;cursor: pointer;"
                      @click="goUserinfo(v.reply_user_info.id)"
                      v-if="v.reply_user_info.nickname != ''"
                      >@{{ v.reply_user_info.nickname }}</a
                    >
                    <a
                      style="color:#ff7400;cursor: pointer;"
                      @click="goUserinfo(v.reply_user_info.id)"
                      v-else-if="v.reply_user_info.mobile != ''"
                      >@{{ v.reply_user_info.mobile }}</a
                    >

                    {{ v.content }}
                  </div>
                  <div class="actions">
                    <div v-if="v.user_info.extras.is_zan == 1">
                      <div class="like-active" @click="zanComment(v.id)"></div>
                      <span>{{ v.zan_num }}</span>
                    </div>
                    <div v-else>
                      <div class="like" @click="zanComment(v.id)"></div>
                      <span>{{ v.zan_num }}</span>
                    </div>
                    <div class="reply" @click="showReply(k)"></div>
                    <div class="created-at">
                      <span v-if="token == v.user_id"
                        ><a href="javascript:;" @click="deleteComment(v.id)"
                          >删除评论</a
                        ></span
                      >
                      <span v-else style="margin-top:-10px;margin-right: 5px;">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="举报此评论"
                          placement="top"
                          style="margin-right:0px;"
                        >
                          <div
                            class="report"
                            @click="
                              showDialogReport(
                                v.id,
                                v.user_info.extras.nickname,
                                v.content
                              )
                            "
                            v-if="v.user_info.extras.nickname != null"
                          ></div>
                          <div
                            class="report"
                            @click="
                              showDialogReport(
                                v.id,
                                v.user_info.mobile,
                                v.content
                              )
                            "
                            v-else
                          ></div>
                        </el-tooltip>
                      </span>
                      <span>发布日期：{{ v.created_at }}</span>
                    </div>
                    <!-- <div class="fav"></div> -->
                  </div>

                  <!-- 显示顶级回复框 Start -->
                  <div class="hiddencontent" :ref="k">
                    <div class="h20"></div>
                    <span v-if="user_info.level == 0">
                      <br />
                      <span
                        >在用户首次评论之前，需要填写一份简单的问卷，以达到活跃用户素质；若用户没能完成我们设计的问题，则只能浏览和参与（投票），无法发表言论。我们希望为热爱电影的人群创建一片交流相处的净土，感谢配合
                        ヾ(o◕∀◕)ﾉ</span
                      ><br /><br />
                      <div style="text-align: center;">
                        <el-button type="primary" @click="goTest()"
                          >GO~</el-button
                        >
                      </div>
                    </span>
                    <span v-else-if="token != null">
                      <el-input
                        class="content"
                        type="textarea"
                        :autosize="{ minRows: 5 }"
                        placeholder="回复一个友善的评论吧~"
                        v-model="son_content"
                      >
                      </el-input>
                      <div style="text-align:center;">
                        <el-button
                          type="primary"
                          style="width:120px;"
                          @click="publishSonContent(v.id)"
                          >回 复</el-button
                        >
                      </div>
                    </span>
                    <span v-else>
                      <br />
                      <div style="text-align:center;">
                        登录后才能参与讨论呀~<br /><br />
                        <router-link to="/login">
                          <el-button type="primary" style="width:120px;"
                            >登 录</el-button
                          >
                        </router-link>
                      </div>
                    </span>
                  </div>
                  <!-- 显示顶级回复框 End -->
                </div>
              </div>
            </div>
            <!-- 评论列表 End -->

            <!-- 影评 End -->
            <el-divider></el-divider>
          </div>
        </div>
        <!-- 举报评论 Start -->
        <el-dialog title="举报评论" :visible.sync="dialog_report_visible">
          <el-form :model="form">
            <el-form-item label="举报的用户为：" :label-width="formLabelWidth">
              <el-input
                v-model="form.report_nickname"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="违规行为：" :label-width="formLabelWidth">
              <!-- <el-select v-model="form.report_type" placeholder="请选择违规行为">
                <el-option label="口头谩骂" value="口头谩骂"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
                </el-select> -->
              <el-radio-group
                v-model="form.report_reason"
                style="line-height: 40px;margin-top:5px;"
              >
                <el-radio label="违法违规">违法违规</el-radio>
                <el-radio label="色情低俗">色情低俗</el-radio>
                <el-radio label="赌博诈骗">赌博诈骗</el-radio>
                <el-radio label="人身攻击">人身攻击</el-radio>
                <el-radio label="侵犯隐私">侵犯隐私</el-radio>
                <el-radio label="垃圾广告">垃圾广告</el-radio>
                <el-radio label="不明链接">不明链接</el-radio>
                <el-radio label="引战">引战</el-radio>
                <el-radio label="剧透">剧透</el-radio>
                <el-radio label="刷屏">刷屏</el-radio>
                <el-radio label="抢楼">抢楼</el-radio>
                <el-radio label="内容不相关">内容不相关</el-radio>
                <el-radio label="其他">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="举报原因：" :label-width="formLabelWidth">
              <el-input
                type="textarea"
                placeholder="请说明举报原因"
                v-model="form.report_content"
                maxlength="100"
                show-word-limit
                :autosize="{ minRows: 5 }"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialog_report_visible = false">取 消</el-button>
            <el-button type="info" @click="sendReport()">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 举报评论 End -->
        <!-- 举报文章 Start -->
        <el-dialog title="举报文章" :visible.sync="forum_dialog_report_visible">
          <el-form :model="forum_form">
            <el-form-item label="举报的文章为：" :label-width="formLabelWidth">
              <el-input
                v-model="forum.title"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="违规行为：" :label-width="formLabelWidth">
              <el-radio-group
                v-model="forum_form.report_reason"
                style="line-height: 40px;margin-top:5px;"
              >
                <el-radio label="违法违规">违法违规</el-radio>
                <el-radio label="色情低俗">色情低俗</el-radio>
                <el-radio label="赌博诈骗">赌博诈骗</el-radio>
                <el-radio label="人身攻击">人身攻击</el-radio>
                <el-radio label="侵犯隐私">侵犯隐私</el-radio>
                <el-radio label="垃圾广告">垃圾广告</el-radio>
                <el-radio label="不明链接">不明链接</el-radio>
                <el-radio label="引战">引战</el-radio>
                <el-radio label="剧透">剧透</el-radio>
                <el-radio label="其他">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="举报原因：" :label-width="formLabelWidth">
              <el-input
                type="textarea"
                placeholder="请说明举报原因"
                v-model="forum_form.report_content"
                maxlength="100"
                :autosize="{ minRows: 5 }"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="forum_dialog_report_visible = false"
              >取 消</el-button
            >
            <el-button type="info" @click="sendReportForum()">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 举报文章 End -->
        <div class="h20"></div>
      </div>
    </transition>
  </div>
</template>
<script>
import Goback from "@/components/components/goback";
export default {
  data() {
    return {
      isback:false,
      loading: 0,
      //当前登录用户的id
      token: 0,
      user_info: {},
      //论坛Id
      fid: 0,
      //论坛信息
      forum: {
        title: "",
        content: ""
      },
      //所有评论
      comments: [],
      //发布评论的内容
      content: "",
      //发布子评论的内容
      son_content: "",
      //显示子级评论框
      showContent: false,
      //电影like的样式
      likeplain: "likeplain",
      //当前用户是否收藏
      favforum: "fav",
      //电影喜欢的样式
      favplain: "favplain",
      forum_dialog_report_visible: false,
      forum_form: {
        report_reason: "",
        report_content: ""
      },
      //dialog举报
      dialog_report_visible: false,
      form: {
        report_cid: 0,
        report_comment: "",
        report_nickname: "",
        report_reason: "",
        report_content: ""
      },
      formLabelWidth: "120px"
    };
  },
  updated(){
    if(this.isback){
      setTimeout(()=>{
        // console.log(this.isback)
        // console.log('updated')
          this.getUserinfo();
          this.goSelfComment();
          this.isback = false
        },100)
    }
  },
  watch: {
    //路由改变时执行
    $route(newVal, oldVal) {
      this.forum = {};
      if (oldVal.name == "test") {
        // console.log('route')
        this.isback = true
        this.getUserinfo();
        // this.goSelfComment();
        // $('html, body').animate({scrollTop: $('#test_enter').offset().top}, 250)
      }
      if (newVal.name == "forumdetail") {
        this.loading = 0;
        this.$parent.activeIndex = "4";
        this.fid = this.$route.params.fid;
        // console.log(this.fid)
        this.getForum();
        this.getForumComment();
        this.judgeForumFav();
        // this.loading = 1
        this.openFullScreen();
      }
    }
  },
  mounted() {
    this.$parent.activeIndex = "4";
    this.loading = 0;

    this.token = localStorage.getItem("token");
    this.fid = this.$route.params.fid;
    // console.log(this.fid)
    this.getUserinfo();
    this.getForum();
    this.getForumComment();
    this.judgeForumFav();
    // this.loading = 1
    this.openFullScreen();
  },
  methods: {
    //答完题后的锚点跳转
    goSelfComment() {
      console.log(111);
      $("html, body").animate({ scrollTop: $("#test_enter").offset().top },0);
    },

    //获取当前用户的信息
    getUserinfo() {
      // console.log(this.token)
      if (this.token == null) {
        return false;
      }
      $.ajax({
        url: "//"+ this.$API_URL +"/api/v1/user_info/" + this.token,
        type: "get",
        success: ret => {
          this.user_info = ret.data;
        }
      });
    },
    //获取文章详情
    getForum() {
      $.ajax({
        url: "//"+ this.$API_URL +"/api/v1/articles/" + this.fid,
        type: "get",
        success: ret => {
          this.forum = ret.data;
          this.loading = 1;
          this.openFullScreen();
        }
      });
    },
    //跳转到编辑文章
    editForum() {
      this.$router.push("/editforum/" + this.fid).catch(err => {
        err;
      });
    },
    //显示举报评论对话框
    showForumDialogReport(id, nickname, comment) {
      if (localStorage.getItem("token") == null) {
        this.$message({
          showClose: true,
          message: "请先登录~",
          type: "info"
        });
        return false;
      }
      if (this.form.report_cid != id) {
        this.form.report_cid = id;
        this.form.report_reason = "";
        this.form.report_content = "";
      }
      this.form.report_nickname = nickname;
      this.form.report_comment = comment;

      this.forum_dialog_report_visible = true;
    },

    //判断用户是否收藏该文章
    judgeForumFav() {
      $.ajax({
        url:
          "//"+ this.$API_URL +"/api/v1/articles/is_fav_article/" + this.fid,
        type: "post",
        data: { user_id: localStorage.getItem("token") },
        success: ret => {
          if (ret.code == 200) {
            this.favforum = "fav-active";
            // $(".fav").attr("class", "fav-active");
          } else {
            this.favforum = "fav";
            // $(".fav-active").attr("class", "fav");
          }
        }
      });
    },
    //收藏文章
    favForum() {
      // console.log(this.token)
      if (this.token == null) {
        this.$message({
          showClose: true,
          message: "登录后才能收藏呀~ Σ( ° △ °|||)︴ ",
          type: "warning"
        });
        return false;
      }
      $.ajax({
        url: "//"+ this.$API_URL +"/api/v1/articles/fav/" + this.fid,
        type: "post",
        data: { user_id: localStorage.getItem("token") },
        success: ret => {
          if (ret.code == 201) {
            this.$message({
              showClose: true,
              message: "收藏文章成功~",
              type: "success"
            });
            $(".fav").attr("class", "fav-active");
            this.forum.fav_count++;
          }
          if (ret.code == 204) {
            this.$message({
              showClose: true,
              message: "取消收藏成功~",
              type: "success"
            });
            $(".fav-active").attr("class", "fav");
            this.forum.fav_count--;
          }
        }
      });
    },

    //举报文章
    sendReportForum() {
      //
      if (this.forum_form.report_reason == "") {
        this.$message({
          showClose: true,
          message: "请选择违规行为",
          type: "info"
        });
        return false;
      }
      $.ajax({
        url: "//"+ this.$API_URL +"/api/v1/articles/report/" + this.fid,
        type: "post",
        data: {
          report_user_id: localStorage.getItem("token"),
          reasons: this.forum_form.report_reason,
          content: this.forum_form.report_content
        },
        success: ret => {
          this.$message({
            showClose: true,
            message: ret.msg,
            type: "info"
          });
          this.forum_form.report_reason = "";
          this.forum_form.report_content = "";
          this.forum_dialog_report_visible = false;
        }
      });
    },
    //删除文章
    deleteForum() {
      this.$confirm("此操作将删除该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = 0;
          this.openFullScreen();
          $.ajax({
            url:
              "//"+ this.$API_URL +"/api/v1/articles/delete_self_articles/" +
              this.fid,
            type: "post",
            data: { user_id: this.token },
            success: ret => {
              this.$message({
                showClose: true,
                message: "文章删除成功",
                type: "success"
              });
              this.loading = 1;
              this.openFullScreen();
              this.goback();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //获取文章下的所有评论
    getForumComment() {
      if (this.token != null) {
        $.ajax({
          url:
            "//"+ this.$API_URL +"/api/v1/comments/articles/" +
            this.fid +
            "?uid=" +
            this.token,
          type: "get",
          success: ret => {
            this.comments = ret.data;
          }
        });
      } else {
        $.ajax({
          url: "//"+ this.$API_URL +"/api/v1/comments/articles/" + this.fid,
          type: "get",
          success: ret => {
            this.comments = ret.data;
          }
        });
      }
    },

    //评论发布（顶级）
    publishContent(pid = 0) {
      //
      if (this.content.length < 5) {
        this.$message({
          showClose: true,
          message: "至少评论5个字呀~  Σ( ° △ °|||)︴ ",
          type: "error"
        });
        return false;
      }
      $.ajax({
        url: "//"+ this.$API_URL +"/api/v1/articles/comments/create",
        type: "post",
        data: {
          article_id: this.fid,
          user_id: localStorage.getItem("token"),
          pid: pid,
          content: this.content
        },
        success: ret => {
          if (ret.code == 201) {
            this.$message({
              showClose: true,
              message: ret.msg,
              type: "success"
            });
            this.content = "";
          } else {
            this.$message({
              showClose: true,
              message: ret.data.content[0],
              type: "error"
            });
          }
          this.getForumComment();
        }
      });
    },
    //子评论发布
    publishSonContent(pid = 0) {
      if (this.son_content.length < 5) {
        this.$message({
          showClose: true,
          message: "至少评论5个字呀~  Σ( ° △ °|||)︴ ",
          type: "error"
        });
        return false;
      }
      $.ajax({
        url: "//"+ this.$API_URL +"/api/v1/articles/comments/create",
        type: "post",
        data: {
          article_id: this.fid,
          user_id: localStorage.getItem("token"),
          pid: pid,
          content: this.son_content
        },
        success: ret => {
          if (ret.code == 201) {
            this.$message({
              showClose: true,
              message: ret.msg,
              type: "success"
            });
            this.son_content = "";
          } else {
            this.$message({
              showClose: true,
              message: ret.data.content[0],
              type: "error"
            });
          }
          $(".showcontent").attr("class", "hiddencontent");
          $(".reply-active").attr("class", "reply");
          this.getForumComment();
        }
      });
    },

    //删除自己的评论
    deleteComment(id) {
      this.$confirm("此操作将删除该评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.ajax({
            url:
              "//"+ this.$API_URL +"/api/v1/articles/comments/delete_self_comments/" +
              id,
            type: "post",
            data: { user_id: localStorage.getItem("token") },
            success: ret => {
              if (ret.code == 204) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getForumComment();
              } else {
                this.$message({
                  type: "info",
                  message: "该评论已不存在!"
                });
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //显示/隐藏回复框
    showReply(k) {
      // this.showContent = !this.showContent
      //
      if (!localStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: '需要登录呀~ (￣▽￣")',
          type: "warning"
        });
        return false;
      }
      //只允许同时打开一个回复框

      //获取点击的标签
      var tag = this.$refs[k];

      //获取点击的标签的样式
      var clas = $(tag).attr("class");
      //
      if (clas == "hiddencontent") {
        $(".showcontent").attr("class", "hiddencontent");
        $(".reply-active").attr("class", "reply");

        // event.attr('class','reply-active')

        $(tag)
          .parent()
          .find(".reply")
          .attr("class", "reply-active");
        //
        $(tag).attr("class", "showcontent");
      } else {
        $(tag)
          .parent()
          .find(".reply-active")
          .attr("class", "reply");

        $(tag).attr("class", "hiddencontent");
      }
    },

    //用户点赞
    zanComment(cid) {
      if (!localStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: '需要登录呀~ (￣▽￣")',
          type: "warning"
        });
        return false;
      }
      $.ajax({
        url: "//"+ this.$API_URL +"/api/v1/articles/comments/zan/" + cid,
        type: "post",
        data: { user_id: this.token },
        success: ret => {
          this.$message({
            showClose: true,
            message: ret.msg,
            type: "success"
          });
          this.getForumComment();
        }
      });
    },
    //显示举报评论对话框
    showDialogReport(id, nickname, comment) {
      if (localStorage.getItem("token") == null) {
        this.$message({
          showClose: true,
          message: "请先登录~",
          type: "info"
        });
        return false;
      }
      if (this.form.report_cid != id) {
        this.form.report_cid = id;
        this.form.report_reason = "";
        this.form.report_content = "";
      }
      this.form.report_nickname = nickname;
      this.form.report_comment = comment;

      this.dialog_report_visible = true;
    },

    //发送举报
    sendReport() {
      if (this.form.report_reason == "") {
        this.$message({
          showClose: true,
          message: "请选择违规行为",
          type: "info"
        });
        return false;
      }
      $.ajax({
        url:
          "//"+ this.$API_URL +"/api/v1/articles/comments/report_comment/" +
          this.form.report_cid,
        type: "post",
        data: {
          report_user_id: localStorage.getItem("token"),
          reasons: this.form.report_reason,
          content: this.form.report_content
        },
        success: ret => {
          // if(ret.code==200){
          this.$message({
            showClose: true,
            message: ret.msg,
            type: "info"
          });
          this.dialog_report_visible = false;
          // }
        }
      });
    },

    //页面加载中
    openFullScreen() {
      const loading = this.$loading({
        lock: true,
        text: "加载中（￣口￣）。。。",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      // setTimeout(() => {
      if (this.loading == 1) {
        loading.close();
      }
      // }, 2000);
    },

    //点击用户名或头像跳转到用户信息页
    goUserinfo(uid) {
      this.$router.push("/user/" + uid).catch(err => {
        err;
      });
    },
    //返回
    goback() {
      this.$router.go(-1);
    },
    //去Test页面
    goTest() {
      // $('html, body').animate({scrollTop: $('#test_enter').offset().top}, 250)
      this.$router.push("/test").catch(err => {
        err;
      });
    }
  },
  components: {
    Goback
  }
};
</script>
<style>
.author-pic {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  float: left;
  margin-top: 10px;
  cursor: pointer;
  /* border:1px solid #fff; */
}
.author:hover .author-pic {
  /* border:1px solid #ff7400; */
}
.author-name {
  margin-left: 10px;
  float: left;
  line-height: 60px;
}
.author:hover .author-name {
  color: #ff7400;
  cursor: pointer;
}
.forum-info {
  margin-left: 20px;
  float: left;
}
.forum-info-son {
  float: left;
  line-height: 60px;
  margin-left: 20px;
  color: #666;
}
.forum-pubdate {
  float: right;
  /* padding-right: 20px; */
  line-height: 60px;
}
.forum-pubdate-son {
  font-size: 14px;
  float: left;
  margin-left: 10px;
  color: #999;
}
.forum-action {
  cursor: pointer;
}
.forum-action:hover {
  color: #ff7400;
}
.forum-content {
  width: 1120px;
  overflow: hidden;
}
.comment-head {
  cursor: pointer;
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  vertical-align: middle;
  border: 1px solid #ccc;
  float: left;
  margin-right: 10px;
}

.hiddencontent {
  display: none;
}
.showcontent {
  padding: 0 50px;
  display: block;
}
.son-hiddencontent {
  display: none;
}
.son-showcontent {
  display: block;
}
.comment-title {
  cursor: pointer;
  font-size: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.comment-body {
  padding: 10px 10px 10px 50px;
}
.son-content {
  padding-left: 50px;
}
.content {
  margin-top: 20px;
  margin-bottom: 20px;
}
.actions {
  /* display: flex; */
  margin-top: 10px;
  margin-left: 48px;
  justify-content: space-between;
  /* width:120px; */
  /* width:250px; */
}
.actions span {
  float: left;
  line-height: 30px;
  margin-right: 20px;
}
.like {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  background-image: url("/static/icon/like.png");
}
.like:hover {
  opacity: 0.5;
  background-image: url("/static/icon/like_at.png");
}

.like-active {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  background-image: url("/static/icon/like_at.png");
}

.fav {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  background-image: url("/static/icon/fav.png");
}
.fav:hover {
  opacity: 0.5;
  background-image: url("/static/icon/fav_at.png");
}
.fav-active {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  background-image: url("/static/icon/fav_at.png");
}
.reply {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  background-image: url("/static/icon/reply.png");
}
.reply:hover {
  opacity: 0.5;
  background-image: url("/static/icon/reply_at.png");
}
.reply-active {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  background-image: url("/static/icon/reply_at.png");
}
.created-at {
  float: right;
  line-height: 30px;
  font-size: 14px;
  color: #666;
}
.created-at a {
  margin-right: 5px;
  color: #999;
  text-decoration: none;
}
.created-at a:hover {
  color: #ff2b78;
}
.created-at span {
  /* float: left; */
  /* line-height: 30px; */
  margin-right: 10px;
}
.report {
  text-align: center;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-top: 15px;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-image: url("/static/icon/report.png");
  background-size: 20px 20px;
}
.report:hover {
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid red;
  background-image: url("/static/icon/report_at.png");
}

/* 富文本的对齐方式 */
.ql-align-center {
  text-align: center;
}
.ql-align-right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/index/forumdetail.vue